export const getCategoryDisplay = (category) =>
  category === 'CFN' ? 'Family Member' : category
